import FeedbackPage from "@components/FeedbackPage"

export default function Motivational1() {
  return (
    <FeedbackPage
      emoji="🏋️"
      titleKey="pages.onboarding.motivational1.heading"
      textKey="pages.onboarding.motivational1.info"
      buttonKey="pages.onboarding.motivational1.button"
    />
  )
}
